import { useFormik } from "formik"
import DatePickers from "global/DatePicker/DatePicker"
import Modal from "global/Modal/Modal"
import SimpleButton from "global/SimpleButton/SimpleButton"
import { useEffect } from "react"
import { toast } from "react-toastify"
import { addEditDataAPI } from "services/CRUDServices"

function ExpireDate({ open, setOpen, currentData, refreshTable }) {

  const { values, setFieldValue, handleSubmit, resetForm, isSubmitting } =
    useFormik({
      enableReinitialize: true,

      initialValues: {
        date: currentData.creditExpirationDate,
      },
      onSubmit: async () => {
        await addEditDataAPI(
          `/core-api/hub_credit/changeExpireDate/${currentData.id}`,
          "post",
          values.date
        )
        toast.success("با موفقیت انجام شد")
        setOpen({ ...open, expireData: false })
        refreshTable()
      },
    })

  useEffect(() => {
    !open && resetForm({})
  }, [open])

  return (
    <Modal visible={open} setVisible={setOpen} title=' '>
      <form onSubmit={handleSubmit}>
        <DatePickers
          title={"تاریخ"}
          values={values.date}
          name={"date"}
          WrapperClassName='filterInput'
          handleChange={setFieldValue}
        />
        <div className='btnForm'>
          <SimpleButton
            handelClick={() => setOpen({ ...open, expireData: false })}
            text='انصراف'
            className='text-tomato'
          />
          <SimpleButton
            type='submit'
            text='تایید '
            className='full-tomato-btn'
            loading={isSubmitting}
          />
        </div>
      </form>
    </Modal>
  )
}

export default ExpireDate
